import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { FunctionComponent } from 'react';
import styles from './WizardExitModal.module.scss';

interface WizardExitModalProps {
    /** Called when the user confirms the exit. The wizard closes; the draft
     * stays persisted in the backend and the user can resume it from the
     * Drafts list later. */
    onLeave: () => void;
    /** Called when the user dismisses the modal and stays in the wizard. */
    onKeepEditing: () => void;
}

/**
 * Confirmation modal shown when the user clicks X on the wizard while a
 * draft already exists in the backend.
 *
 * The copy intentionally reassures the user that nothing is being lost — the
 * draft auto-persists at each Continue, so "leaving" really means just
 * navigating away. To actually discard the campaign the user goes to the
 * Drafts list and uses the Delete action there. (Standard pattern in
 * Klaviyo / Mailchimp / HubSpot.)
 */
const WizardExitModal: FunctionComponent<WizardExitModalProps> = ({ onLeave, onKeepEditing }) => {
    return (
        <GenericModal
            footer={
                <div className={styles.footer}>
                    <Button
                        className={styles.button}
                        label="Keep editing"
                        variant="outlined"
                        onClick={onKeepEditing}
                    />
                    <Button
                        className={styles.button}
                        label="Leave"
                        variant="danger"
                        onClick={onLeave}
                    />
                </div>
            }
            onClose={onKeepEditing}
        >
            <span className={styles.title}>Leave campaign creation?</span>
            <span className={styles.text}>
                Your draft is saved automatically. You can resume it any time from the Drafts list.
            </span>
        </GenericModal>
    );
};

export default WizardExitModal;
